module.exports = __webpack_public_path__ + "static/images/list-g.bb87a64.png";